import { render, staticRenderFns } from "./PlgMenu.vue?vue&type=template&id=4c29b670&scoped=true"
import script from "./PlgMenu.vue?vue&type=script&lang=ts"
export * from "./PlgMenu.vue?vue&type=script&lang=ts"
import style0 from "./PlgMenu.vue?vue&type=style&index=0&id=4c29b670&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c29b670",
  null
  
)

export default component.exports